<template>
  <module-layout class="page-module">
    <Loader v-if="loading"></Loader>
    <section class="module-viewer" v-else>

      <span class="mobile-menu-toggle" @click="isMobileSidebarOpen = !isMobileSidebarOpen">
        <div class="menu-icon" :class="{ 'open': isMobileSidebarOpen }"><span></span><span></span><span></span></div>
      </span>

      <div class="module-sidebar" :class="{ 'is-open': isMobileSidebarOpen }">
        <div :class="['module-data', $route.params.section]">
          <div class="headerButtons">
            <router-link class="back" :to="{ name: 'dashboard'}">&#9664; Back</router-link>
            <Button size="small"
              :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section: 'resources', unit: 1 } }"
              type="resources">RESOURCES</Button>
          </div>
          <div class="topButtons">
            <Button
              :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section: 'nursery-pre-school' } }"
              :type="$route.params.section == 'nursery-pre-school' ? 'primary':'nursery-pre-school'"
              size="small">NURSERY & PRE-SCHOOL</Button>
            <Button size="small"
              :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section: 'pre-kindergarten' } }"
              :type="$route.params.section == 'pre-kindergarten' ? 'primary':'pre-kindergarten'">PRE-KINDERGARTEN</Button>
            <Button size="small"
              :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section: 'kindergarten' } }"
              :type="$route.params.section == 'kindergarten' ? 'primary':'kindergarten'">KINDERGARTEN</Button>
          </div>

          <div class="search-field">
            <div class="input-group">
            <input v-model="search" type="text" placeholder="Search" @keyup.enter="loadSearch">
            <span><img width="18px" height="18px" src="/static/img/search.svg" @click="loadSearch"></span>
            </div>
            <div>
              <a href="javascript:;" @click="expandAdvancedSearch">Advanced Search</a>
                <transition name="expand">
                  <div v-show="isAdvancedOpen">
                    <p>Curricular Year</p>

                      <input v-model="searchTerm" type="checkbox" id="term-kinder" :value="3">
                      <label for="term-kinder">Kindergarten</label>

                      <input v-model="searchTerm" type="checkbox" id="term-pre" :value="2">
                      <label for="term-pre">Pre-Kindergarten</label>

                      <input v-model="searchTerm" type="checkbox" id="term-nursery" :value="1">
                      <label for="term-nursery">Nursery & Preschool</label>

                    <p>Subject</p>
                      <input v-model="searchSubject" type="checkbox" id="sub-math" name="subject" :value="1">
                      <label for="sub-math">Mathematics</label>

                      <input v-model="searchSubject" type="checkbox" id="sub-lang" name="subject" :value="2">
                      <label for="sub-lang">Language & Communication</label>

                      <input v-model="searchSubject" type="checkbox" id="sub-arts" name="subject" :value="3">
                      <label for="sub-arts">Arts & Crafts</label>

                      <input v-model="searchSubject" type="checkbox" id="sub-edu" name="subject" :value="4">
                      <label for="sub-edu">Environmental Education</label>

                      <input v-model="searchSubject" type="checkbox" id="sub-phy" name="subject" :value="5">
                      <label for="sub-phy">Physical Education</label>

                      <input v-model="searchSubject" type="checkbox" id="sub-music" name="subject" :value="6">
                      <label for="sub-music">Music</label>

                    <p>Search Only In</p>
                      <input v-model="searchOnly" type="checkbox" id="search-act" name="search" value="intro">
                      <label for="search-act">Activities</label>

                      <input v-model="searchOnly" type="checkbox" id="search-mat" name="search" value="materials">
                      <label for="search-mat">Materials</label>

                      <input v-model="searchOnly" type="checkbox" id="search-goals" name="search" value="goals">
                      <label for="search-goals">Goals</label>

                      <input v-model="searchOnly" type="checkbox" id="search-eva" name="search" value="evaluation">
                      <label for="search-eva">Evaluations</label>

                  </div>
                </transition>
            </div>
          </div>

        </div>
        <div v-show="termsInfo" :class="['manual-nav', $route.params.section]">
            <div class="field">
                <div class="control">
                    <div class="select is-primary">
                    <select @change="(e) => this.loadContent(e.target.value)"  :value="selectedUnitId">
                        <option v-bind:key="index" v-for="(unit,index) in units" :value="unit.id">Unit {{ (index + 1) }}: {{ unit.name }}</option>
                    </select>
                    </div>
                </div>
            </div>
            <div class="field">
                <div class="control">
                    <div class="select is-primary">
                    <select  @change="(e) => this.loadContent(selectedUnit.id, e.target.value)"  :value="selectedWeekId">
                        <option value="">Select Week</option>
                        <option v-bind:key="index" v-for="(week,index) in weeks" :value="week.id">Week {{ (index + 1) }}: {{ week.name }}</option>
                    </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="module-nav">
          <div class="module-nav-item" :class="selectedLessonId == lesson.id ? 'active' : ''" v-for="(lesson,key) in lessons" :key="lesson.id">
            <router-link :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section: $route.params.section, unit: selectedUnit.id, week: selectedWeek.id, lesson: lesson.id }}">{{ (key + 1) }}. {{ lesson.name }}</router-link>
          </div>
          <div v-if="isResourcesPage" class="module-nav-item" :class="$route.params.unit == resourceFilter.id? 'active':''" v-for="(resourceFilter) in resourceFilters" :key="resourceFilter.id">
            <router-link :to="{ name: 'manualContent', query: { lang: $route.query.lang || 1 }, params: { section:'resources', unit: resourceFilter.id } }">{{ resourceFilter.name }}</router-link>
          </div>
        </div>
      </div>
      <div class="module-content">
        <ManualContent v-if="dayInfo !== null && !isUnitPage && !isResourcesPage && !isSearchPage" :content="dayInfo" :selectedDayWeekNumber="selectedDayWeekNumber"></ManualContent>
        <UnitContent v-if="isUnitPage && loadedUnitInfo" :content="unitInfo"></UnitContent>
        <ManualResourceContent v-if="isResourcesPage && loadedResources" :content="resources" :selected="selectedType.name"></ManualResourceContent>
        <ManualSearchContent v-if="isSearchPage && loadedSearch" :content="searchList" :filters="{ term: searchTerm, subject: searchSubject, searchin: searchOnly }" :text="search"></ManualSearchContent>
        <div class="home-text" v-if="$route.params.section === 'home'">
          <h2>FUN LEARNING CURRICULUM</h2>
          <p>Explore content by selecting the curricular year, unit week or lesson from the left panel.</p>
          <h2>RESOURCES</h2>
          <p>Access additional resources by clicking on the RESOURCES button.</p>
          <img src="/static/img/assets/manual-home.png"/>
        </div>
      </div>
    </section>
  </module-layout>
</template>

<script>

import ModuleLayout from '@/layouts/ModuleLayout'
import ManualContent from '@/components/ManualContent'
import UnitContent from '@/components/UnitContent'
import ManualResourceContent from '@/components/ManualResourceContent'
import ManualSearchContent from '@/components/ManualSearchContent'
import ProgressBar from '@/components/ProgressBar'
import Loader from '@/components/Loader'
import FinishLessonButton from '@/components/FinishLessonButton'
import Button from '@/components/Button'
import ManualService from '@/services/ManualService'

const MANUAL_TERMS = {
  'nursery-pre-school': 1,
  'pre-kindergarten': 2,
  'kindergarten': 3
}

export default {
  components: {
    ModuleLayout,
    ManualContent,
    UnitContent,
    ManualResourceContent,
    ManualSearchContent,
    ProgressBar,
    Button,
    Loader,
    FinishLessonButton
  },
  data () {
    return {
      loading: false,
      isAdvancedOpen: false,
      isMobileSidebarOpen: false,
      termFilter: null,
      subjectFilter: null,
      search: '',
      searchTerm: [],
      searchSubject: [],
      searchOnly: [],
      searchList: null,
      module: {},
      termsInfo: null,
      dayInfo: null,
      unitInfo: null,
      resources: null,
      resourceFilters: [
        { id: 1, name: 'Classroom Posters' },
        { id: 2, name: 'Worksheets' },
        { id: 3, name: 'Circletime Printables' },
        { id: 4, name: 'Evaluation Printables' },
        { id: 5, name: 'Classroom Printables' },
        { id: 6, name: 'Songs and Music' }
      ]
    }
  },
  watch: {
    $route (to, from) {
      if (this.isResourcesPage) {
        this.termsInfo = null
        this.unitInfo = null
        this.loadResources()
      } else if (this.isSearchPage) {
        this.termsInfo = null
        this.unitInfo = null
      } else {
        this.loadAllContent()
      }
    }
  },
  computed: {
    selectedDayWeekNumber: function () {
      if (this.termsInfo !== null) {
        let weekNumber
        this.termsInfo.map((term) => {
          term.units.map((unit) => {
            unit.weeks.map((week) => {
              if (week.days.indexOf(this.selectedLesson) !== -1) {
                weekNumber = (week.days.indexOf(this.selectedLesson) + 1)
              }
            })
          })
        })
        return weekNumber
      } else {
        return 0
      }
    },
    loadedUnitInfo: function () {
      return this.unitInfo !== null
    },
    loadedResources: function () {
      return this.resources !== null
    },
    loadedSearch: function () {
      return this.searchList !== null
    },
    isUnitPage: function () {
      if (this.$route.params.section !== 'resources' &&
      this.$route.params.lesson === undefined &&
      this.$route.params.week === undefined) {
        return true
      } else {
        return false
      }
    },
    isResourcesPage: function () {
      if (this.$route.params.section === 'resources') {
        return true
      } else {
        return false
      }
    },
    isSearchPage: function () {
      if (this.$route.params.section === 'search') {
        return true
      } else {
        return false
      }
    },
    selectedUnit: function () {
      if (this.units.length === 0) {
        return null
      } else if (this.$route.params.unit === undefined) {
        return this.units[0]
      } else {
        return this.units.filter(unit => unit.id === parseInt(this.$route.params.unit))[0]
      }
    },
    selectedType: function () {
      if (!this.isResourcesPage && !this.isSearchPage) {
        return null
      } else {
        return this.resourceFilters.filter(unit => unit.id === parseInt(this.$route.params.unit))[0]
      }
    },
    selectedUnitId: function () {
      if (this.units.length === 0) {
        return null
      } else {
        return this.selectedUnit.id
      }
    },
    selectedWeek: function () {
      if (this.$route.params.week === undefined) {
        return []
      } else {
        return this.weeks.filter(week => week.id === parseInt(this.$route.params.week))[0]
      }
    },
    selectedWeekId: function () {
      if (this.$route.params.week === undefined || this.selectedWeek === undefined) {
        return ''
      } else {
        return this.selectedWeek.id
      }
    },
    selectedLesson: function () {
      if (this.isUnitPage) {
        return ''
      } else if (this.$route.params.lesson === undefined) {
        return this.lessons[0]
      } else {
        return this.lessons.filter(lesson => lesson.id === parseInt(this.$route.params.lesson))[0]
      }
    },
    selectedLessonId: function () {
      if (this.isUnitPage) {
        return ''
      } else {
        return this.selectedLesson.id
      }
    },
    units: function () {
      if (this.termsInfo === null) {
        return []
      } else {
        return this.termsInfo.filter(term => term.id === MANUAL_TERMS[this.$route.params.section])[0].units
      }
    },
    weeks: function () {
      if (this.selectedUnit === null || this.selectedUnit === undefined) {
        return []
      } else {
        return this.selectedUnit.weeks
      }
    },
    lessons: function () {
      if (this.selectedWeek === null || this.selectedWeek === undefined) {
        return []
      } else {
        return this.selectedWeek.days
      }
    }
  },
  created () {
    if (this.$route.params.section === 'home' || this.$route.params.section === 'search') {

    } else if (this.isResourcesPage) {
      this.loadResources()
    } else {
      this.loadAllContent()
    }
  },
  methods: {
    expandAdvancedSearch: function () {
      this.isAdvancedOpen = !this.isAdvancedOpen
    },
    loadSearch: function () {
      let options = { search: this.search }

      if (this.searchTerm) {
        options.term = this.searchTerm
      }

      if (this.searchSubject) {
        options.subject = this.searchSubject
      }

      if (this.searchOnly) {
        options.searchin = this.searchOnly
      }

      ManualService.getSearch(options).then((search) => {
        this.searchList = search
        this.$router.push({ name: 'manualContent', query: {}, params: { section: 'search' } })
      })
    },
    loadAllContent: function () {
      ManualService.getAllTermsInfo(this.$route.query.lang || 1).then((termsInfo) => {
        this.termsInfo = termsInfo
        if (this.isUnitPage) {
          this.loadUnitInfo()
        } else {
          ManualService.getDayInfo(this.selectedLesson.id, this.$route.query.lang || 1).then((dayInfo) => {
            this.dayInfo = dayInfo
          })
        }
      })
    },
    loadUnitInfo: function () {
      ManualService.getUnitInfo(this.selectedUnitId, this.$route.query.lang || 1).then((unitInfo) => {
        this.unitInfo = unitInfo
      })
    },
    loadResources: function () {
      ManualService.getResources({ types: [this.$route.params.unit] }).then((resources) => {
        this.resources = resources
      })
    },
    loadContent: function (unit = null, week = null, lesson = null) {
      let params = {
        section: this.$route.params.section
      }

      if (unit !== null) {
        params.unit = unit
      }
      if (week !== null && week !== '') {
        params.week = week
      }
      if (lesson !== null) {
        params.lesson = lesson
      }
      this.$router.push({ name: 'manualContent', query: { lang: this.$route.query.lang || 1 }, params: params })
    }
  }

}
</script>

<style lang="scss">

@import '~styles/base/variables';
@import '~styles/base/mixins';

.home-text{
  p{
    font-size: 0.9rem;
  }
  img{
    margin-top: 2rem;
  }
}

.page-module {

  .headerButtons {
    display: flex;
    justify-content: space-between;
    .button-resources{
      background-color: #00A499;
      &:hover{
        border-color: #00A499;
        box-shadow: none;
      }
    }
  }

  .topButtons {
    margin-top: 15px;
    button.button, a {
      width: 100%;
      margin-bottom:15px;
      display: block;
    }
    margin-bottom: 2rem;
  }

  .search-field {
    margin-top: 4rem;
    margin-bottom: 2rem;
    a{
      color: #000;
      &:hover{
        color: #333;
      }
    }
    p{
      font-weight: 800;
      border-bottom: 1px solid #fff;
      margin-bottom: 0.5rem;
      padding-top: 0.5rem;
    }
    input[type="text"] {
      width: 100%;
      padding: 0.5rem;
      border-radius: .25rem;
      border: none;
      margin-bottom: 15px;
      display: block;
    }
    input[type="checkbox"] + label{
      display: block;
      padding-left: 2em;
      padding-right: 1.5rem;
      padding-bottom: 0.1rem;
      font-size: 0.9rem;
    }
    .input-group{
      position: relative;
      span{
        position: absolute;
        top: 8px;
        right: 8px;
        cursor: pointer;
      }
    }

  }

  .mobile-menu-toggle {
    height: 60px;
    display: flex;
    align-items: center;
    border-left: none;
    cursor: pointer;
  }

  .mobile-menu-toggle {
    display: none;
  }
}

.module-viewer {
  display: flex;
}

.module-content {
  max-width: 40rem;
  width: 100%;
  margin: 0 auto;
  padding: 5rem 1rem;
}

.module-sidebar {
  display: flex;
  flex-direction: column;
  flex: 0 0 300px;
  max-width: 300px;
  border-right: 1px solid $color-gray-light;

  .back {
    @include text-size-xs();
    font-weight: $font-weight-semibold;
    color: $color-white;
    text-transform: uppercase;
    align-self: center;
  }

  .module-data {
    padding: 1.5rem 1.5rem 10rem 1.5rem;
    color: $color-white;

    .button-primary{
      border-color: #fff;
      background-color: #fff;
    }

    .button-nursery-pre-school{
      color: #fff;
      background-color: $color-nursery;
      border-color: $color-nursery;
    }

    .button-pre-kindergarten{
      color: #fff;
      background-color: $color-pre;
      border-color: $color-pre;
    }

    .button-kindergarten{
      color: #fff;
      background-color: $color-kinder;
      border-color: $color-kinder;
    }

    &.home, &.search, &.resources{
      background-color: #818181;
    }

    &.nursery-pre-school{
      background-color: $color-nursery;
      .button-primary{
        color: $color-nursery;
      }
    }

    &.pre-kindergarten{
      background-color: $color-pre;
      .button-primary{
        color: $color-pre;
      }
    }

    &.kindergarten{
      background-color: $color-kinder;
      .button-primary{
        color: $color-kinder;
      }
    }
  }

  .module-number {
    @include text-size-s();
    font-weight: $font-weight-semibold;
    color: rgba($color-white, .56);
    text-transform: uppercase;
  }

  .module-title {
    text-transform: uppercase;
    margin-bottom: 2rem;
    @include text-size-xxl();
    font-weight: $font-weight-semibold;
  }
}

.manual-nav {
  display: flex;
  flex-direction: column;
  max-width: 300px;
  background-color: $color-white;
  padding: 1.5rem;
  color: $color-white;
  background-color: $color-text-dark;
  border-top: 1px solid #fff;
  border-bottom: 1px solid #666;

  &.pre-kindergarten{
    background-color: $color-pre;
  }

  &.kindergarten{
    background-color: $color-kinder;
  }

  .select {
      width: 100%;
      select {
        width: 100%;
        background: none;
        color: #fff;
        border-color: #fff;
        &:disabled {
            opacity:0.2;
        }
      }
  }
  .select:not(.is-multiple)::after {
    border-color: #fff;
  }
}

.module-nav-title {
  padding: 0 1rem 0 2rem;
  font-weight: $font-weight-semibold;
  @include text-size-s();
  color: $color-text-dark;
  text-transform: uppercase;
}

.module-nav-item {

  > a {
    display: flex;
    align-items: center;
    padding: 1.5rem 1rem 1.5rem 2rem;
    font-weight: $font-weight-semibold;
    @include text-size-m();
    color: $color-text-dark;
    word-break: break-word;

    .icon {
      align-self: flex-start;
      flex: 0 0 auto;
      margin-right: .5rem;
    }
  }

  &.active {
    background-color: $color-gray-lighter;
    box-shadow: inset 5px 0 0 0 $color-brand-main;
  }

  &.locked > a {
    cursor: not-allowed;
    pointer-events: none;
    color: $color-text-light;
  }

  &:not(.locked):hover{
    background-color: $color-gray-lighter;
  }
}

@media screen and (max-width: 768px) {

  .page-module {

    .mobile-menu-toggle {
      display: flex;
    }

    .mobile-menu-toggle {
      position: fixed;
      top: 0;
      right: 0;
      width: 4rem;
      max-width: 20vw;
      z-index: 2;
      background-image: linear-gradient(215deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
    }
  }

  .module-sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    height: 100vh;
    width: 80vw;
    max-width: 20rem;
    box-shadow: 2px 0 10px 0 rgba(#e4e5e9, .7);
    z-index: 1;
    transform: translateX(-100%);
    transition: transform .15s ease-in-out;

    &.is-open {
      transform: translateX(0);
    }
  }

  .module-nav {
    overflow-y: auto;
  }
}

.menu-icon {
  width: 26px;
  height: 22px;
  position: relative;
  margin: 0 auto;
  transform: rotate(0deg);
  transition: .5s ease-in-out;
  cursor: pointer;

  span {
    display: block;
    position: absolute;
    height: 4px;
    width: 100%;
    background: #6b7285;
    border-radius: 2px;
    opacity: 1;
    left: 0;
    transform: rotate(0deg);
    transition: .25s ease-in-out;
    transform-origin: left center;
  }

  span:nth-child(1) { top: 0; }
  span:nth-child(2) { top: 50%; transform: scaleX(1) translateY(-50%); }
  span:nth-child(3) { bottom: 0; }

  &.open span:nth-child(1) {
    transform: rotate(45deg);
  }

  &.open span:nth-child(2) {
    transform: scaleX(0) translateY(-50%);
    opacity: 0;
  }

  &.open span:nth-child(3) {
    transform: rotate(-45deg);
  }
}

.expand-enter-active, .expand-leave-active {
  transition: opacity .5s;
}
.expand-enter, .expand-leave-to {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// src/pages/ManualContentPage.vue